// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1W9yR","colMaxWidth":"Table_colMaxWidth__3nz8o"};